import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/operationlog/index',
    method: 'get',
    params: query
  })
}

export function fetchDetail(id) {
  return request({
    url: '/operationlog/detail',
    method: 'get',
    params: { id }
  })
}

export function clear(data) {
  return request({
    url: '/operationlog/clear',
    method: 'post',
    data
  })
}
